import { Tag, Typography } from "antd";
import { useSalesConfigurations } from "sales/queries";
import { formatCommissionRate as formatRate } from "shared/utils/formatCommissionRate";
import "./SalesConfigurationDisplay.scss";

interface SalesConfigurationDisplayProps {
  value?: string;
}

export const SalesConfigurationDisplay = ({
  value,
}: SalesConfigurationDisplayProps) => {
  const { data: configurations } = useSalesConfigurations();
  const config = configurations?.find((c) => c.id === value);

  if (!value || !config) {
    return (
      <Typography.Text type="secondary" className="sales-config-display-none">
        None
      </Typography.Text>
    );
  }

  return (
    <div className="sales-config-display">
      <div className="sales-config-display__row">
        <Tag color="blue" className="sales-config-display__tag">AM</Tag>
        <span className="sales-config-display__name">
          {config.accountManagerName || "Unknown"}
        </span>
        <span className="sales-config-display__rate">
          {formatRate(config.accountManagerCommissionRate)}
        </span>
      </div>
      <div className="sales-config-display__row">
        <Tag color="green" className="sales-config-display__tag">LG</Tag>
        <span className="sales-config-display__name">
          {config.leadGeneratorName || "Unknown"}
        </span>
        <span className="sales-config-display__rate">
          {formatRate(config.leadGeneratorCommissionRate)}
        </span>
      </div>
      <div className="sales-config-display__row">
        <Tag color="orange" className="sales-config-display__tag">SS</Tag>
        <span className="sales-config-display__name">
          {config.salesSupportName || "Unknown"}
        </span>
        <span className="sales-config-display__rate">
          {formatRate(config.salesSupportCommissionRate)}
        </span>
      </div>
    </div>
  );
};
